import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-645bcae7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer" }
const _hoisted_2 = { class: "user-header" }
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Smoke and CO alarm form", -1))
const _hoisted_5 = { class: "col-sm-4" }
const _hoisted_6 = { class: "form-group row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Safety Cleats to Blinds", -1))
const _hoisted_8 = { class: "col-sm-4" }
const _hoisted_9 = { class: "form-group row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Summary email following CO", -1))
const _hoisted_11 = { class: "col-sm-4" }
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Confirm access for diary bookings", -1))
const _hoisted_14 = { class: "col-sm-4" }
const _hoisted_15 = { class: "form-group row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Do Not Contact TT for Inv/CI", -1))
const _hoisted_17 = { class: "col-sm-4" }
const _hoisted_18 = { class: "form-group row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Do Not Contact TT for CO/SOC", -1))
const _hoisted_20 = { class: "col-sm-4" }
const _hoisted_21 = { class: "form-group row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Telephone Lettings", -1))
const _hoisted_23 = { class: "col-sm-3" }
const _hoisted_24 = { class: "form-group row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Emergency Out of hours", -1))
const _hoisted_26 = { class: "col-sm-3" }
const _hoisted_27 = { class: "form-group row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Points of contact", -1))
const _hoisted_29 = { class: "col-sm-9" }
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-645bcae7><div class=\"col-2\" data-v-645bcae7>Name</div><div class=\"col-2\" data-v-645bcae7>Email</div><div class=\"col-2\" data-v-645bcae7>Work</div><div class=\"col-2\" data-v-645bcae7>Mobile</div><div class=\"col-1\" data-v-645bcae7>cc to confirmation</div><div class=\"col-1\" data-v-645bcae7>cc to feedback</div></div>", 1)
const _hoisted_31 = { class: "col-2" }
const _hoisted_32 = ["onUpdate:modelValue", "onChange"]
const _hoisted_33 = { class: "col-2" }
const _hoisted_34 = ["onUpdate:modelValue", "onInput", "onChange"]
const _hoisted_35 = { class: "col-2" }
const _hoisted_36 = ["onUpdate:modelValue", "onChange"]
const _hoisted_37 = { class: "col-2" }
const _hoisted_38 = ["onUpdate:modelValue", "onChange"]
const _hoisted_39 = { class: "col-1" }
const _hoisted_40 = { class: "col-1" }
const _hoisted_41 = { class: "col-1" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-2" }
const _hoisted_47 = { class: "col-2" }
const _hoisted_48 = { class: "col-2" }
const _hoisted_49 = { class: "col-2" }
const _hoisted_50 = { class: "col-1" }
const _hoisted_51 = { class: "col-1" }
const _hoisted_52 = { class: "col-1" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_55 = [
  _hoisted_54
]
const _hoisted_56 = { class: "form-group row" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Inspection in absence", -1))
const _hoisted_58 = { class: "col-sm-4" }
const _hoisted_59 = { class: "form-group row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Inv and CI inspections flex", -1))
const _hoisted_61 = { class: "col-sm-4" }
const _hoisted_62 = { class: "form-group row" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Inv and CI inspections flex AM", -1))
const _hoisted_64 = { class: "col-sm-4" }
const _hoisted_65 = { class: "form-group row" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "CO and SOC inspections flex", -1))
const _hoisted_67 = { class: "col-sm-4" }
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<div class=\"form-group row\" data-v-645bcae7><div class=\"col-sm-9 offset-3\" data-v-645bcae7><div class=\"row\" data-v-645bcae7><div class=\"col-sm-2\" data-v-645bcae7>Booked by</div><div class=\"col-md-2\" data-v-645bcae7>Landlord</div><div class=\"col-md-8\" data-v-645bcae7>Email</div></div></div></div>", 1)
const _hoisted_69 = { class: "form-group row" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Onsite feedback to", -1))
const _hoisted_71 = { class: "col-sm-9" }
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-md-2" }
const _hoisted_74 = { class: "col-md-2" }
const _hoisted_75 = { class: "col-sm-8" }
const _hoisted_76 = { class: "row" }
const _hoisted_77 = { class: "col-4" }
const _hoisted_78 = { class: "col-1" }
const _hoisted_79 = ["disabled"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = { class: "row mt-1" }
const _hoisted_83 = { class: "col-12" }
const _hoisted_84 = {
  key: 0,
  class: "multiselecttags"
}
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "form-group row" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Compliance form to", -1))
const _hoisted_88 = { class: "col-sm-9" }
const _hoisted_89 = { class: "row" }
const _hoisted_90 = { class: "col-md-2" }
const _hoisted_91 = { class: "col-md-2" }
const _hoisted_92 = { class: "col-sm-8" }
const _hoisted_93 = { class: "row" }
const _hoisted_94 = { class: "col-4" }
const _hoisted_95 = { class: "col-1" }
const _hoisted_96 = ["disabled"]
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_98 = [
  _hoisted_97
]
const _hoisted_99 = { class: "row mt-1" }
const _hoisted_100 = { class: "col-12" }
const _hoisted_101 = {
  key: 0,
  class: "multiselecttags"
}
const _hoisted_102 = ["onClick"]
const _hoisted_103 = { class: "form-group row" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "CO cleaning feedback to", -1))
const _hoisted_105 = { class: "col-sm-9" }
const _hoisted_106 = { class: "row" }
const _hoisted_107 = { class: "col-md-2" }
const _hoisted_108 = { class: "col-md-2" }
const _hoisted_109 = { class: "col-sm-8" }
const _hoisted_110 = { class: "row" }
const _hoisted_111 = { class: "col-4" }
const _hoisted_112 = { class: "col-1" }
const _hoisted_113 = ["disabled"]
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save" }, null, -1))
const _hoisted_115 = [
  _hoisted_114
]
const _hoisted_116 = { class: "row mt-1" }
const _hoisted_117 = { class: "col-12" }
const _hoisted_118 = {
  key: 0,
  class: "multiselecttags"
}
const _hoisted_119 = ["onClick"]
const _hoisted_120 = { class: "form-group row" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Key release required ", -1))
const _hoisted_122 = { class: "col-sm-4" }
const _hoisted_123 = { class: "form-group row" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Opening Hours", -1))
const _hoisted_125 = { class: "col-6" }
const _hoisted_126 = { class: "col-sm-1" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-1" }, "Closed:", -1))
const _hoisted_128 = { class: "col-sm-1" }
const _hoisted_129 = { class: "col-sm-2" }
const _hoisted_130 = { class: "col-sm-2" }
const _hoisted_131 = { class: "form-group row" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Misc Notes", -1))
const _hoisted_133 = { class: "col-sm-6" }
const _hoisted_134 = { class: "form-group row" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Long Term PI Notes", -1))
const _hoisted_136 = { class: "col-sm-6" }

import moment from 'moment-timezone';
  import { ref, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { Contact, Customer } from "@/models";
  import { DxSwitch } from 'devextreme-vue/switch';  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'LogisticsRules',
  setup(__props) {

  const dayOfWeek = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const newcontact = ref(new Contact);
  const onsitefeedbacktonewemail = ref('');
  const complianceformtonewemail = ref('');
  const cocleaningfeedbacktonewemail= ref('');
  const isEmailValid = ref(true);
  const isupdateEmailValid = ref(true);

  const store = useStore();
  const customer = computed((): Customer => store.getters['customers/current']);
  const editCustomer = async (customer: Customer) => await store.dispatch('customers/editCustomer', customer);
  const setCustomerDeep = async (payload: {
    path: string;
    data: any;
  }) => {
    await store.dispatch('customers/setCustomerDeep', payload);
  }

  const isDropdownDisabled = (oh) => {
    return oh.closed;
  };

  const timeoptions = ref([]);

  onMounted(() => {
    timeoptions.value = [];
    let startmoment = moment().set("hour", 0).set("minute", 0);
    for (let i = 0; i < 96; i++) {
      const hourMinutes = startmoment.format("HH:mm");
      timeoptions.value.push(hourMinutes);
      startmoment.add(15, "minutes");
    }
  });

  const getTimeOptionsForFrom = (toTime: string) => {
    const toMoment = moment(toTime, "HH:mm").subtract(15, 'minutes');
    const fromOptions = timeoptions.value.filter((time) => {
      const fromMoment = moment(time, "HH:mm");
      return fromMoment.isSameOrBefore(toMoment);
    });
  return fromOptions;
};

  const getTimeOptionsForTo = (fromTime: string) => {
      const fromMoment = moment(fromTime, "HH:mm").add(15, 'minutes');
      const toOptions = timeoptions.value.filter((time) => {
        const toMoment = moment(time, "HH:mm");
        return toMoment.isSameOrAfter(fromMoment);
      });
    return toOptions;
  };

  const setOpeningTimeFrom = (index: number, val: string) => {
    setCustomerDeep({path:`policies.openinghours[${index}].from`, data: val});
  }
  const setOpeningTimeTo = (index: number, val: string) => {
    setCustomerDeep({path:`policies.openinghours[${index}].to`, data: val});
  }

  const deletePointofcontact = (index: number) => {
    if(index < 0) return;
    const list: Contact[] = customer.value.policies.contactlist;
    list.splice(index, 1);
    setCustomerDeep({path: 'policies.contactlist', data: [...list]});
  }

  const addPointofcontact = () => {
    if(!newcontact.value.name) return false;
    if(!newcontact.value.phone && !newcontact.value.mobile && !newcontact.value.email) return false;
    const list: Contact[] = customer.value.policies.contactlist;
    list.push(new Contact(newcontact.value));
    newcontact.value = new Contact;
    setCustomerDeep({path: 'policies.contactlist', data: [...list]});
  }

  const canSavePOC = () => {
    if(!newcontact.value.name) return false;
    if(!newcontact.value.phone && !newcontact.value.mobile && !newcontact.value.email) return false;

    let checkname = customer.value.policies.contactlist.filter((f)=> f.name == newcontact.value.name);
    if(checkname.length > 0 ){
      return false;
    }

    return true;
  }
  
  const editCurrentCustomer = () => {
    editCustomer(customer.value);
  };

  //TelephoneLetting
  const telephoneLetting = computed({
    get: () => { return customer.value.policies.phone},
    set: (val: string) => { setCustomerDeep({path: 'policies.phone', data: val})}
  });

  //Emergency Out of Hours
  const emergencyphone = computed({
    get: () => { return customer.value.policies.emergencyphone},
    set: (val: string) => { setCustomerDeep({path: 'policies.emergencyphone', data: val})}
  });

  //Inspection in absence
  const inspectioninabs = computed({
    get: () => { return customer.value.policies.inspectioninabs},
    set: (val: boolean) => { setCustomerDeep({path: 'policies.inspectioninabs', data: val})}
  });

  //Inv and CI inspections flex
  const invciflex = computed({
    get: () => { return customer.value.policies.invciflex},
    set: (val: boolean) => { setCustomerDeep({path: 'policies.invciflex', data: val})}
  });

   //Inv and CI inspections flex AM
  const invciflexam = computed({
    get: () => { return customer.value.policies.invciflexam},
    set: (val: boolean) => { setCustomerDeep({path: 'policies.invciflexam', data: val})}
  });

  //CO and SOC inspections flex
  const cosocflex = computed({
    get: () => { return customer.value.policies.cosocflex},
    set: (val: boolean) => { setCustomerDeep({path: 'policies.cosocflex', data: val})}
  });

  //Onsite feedback to booked by
  const onsitefeedbacktobookedby = computed({
    get: () => { return customer.value.policies.onsitefeedbackto.bookedby},
    set: (val: boolean) => { setCustomerDeep({path: 'policies.onsitefeedbackto.bookedby', data: val})}
  });
  
  //Onsite feedback to landlord
  const onsitefeedbacktolandlord = computed({
    get: () => { return customer.value.policies.onsitefeedbackto.landlord},
    set: (val: boolean) => { setCustomerDeep({path: 'policies.onsitefeedbackto.landlord', data: val})}
  });

  //Onsite feedback to Email
  const onsitefeedbacktoemail = computed({
    get: () => { return customer.value.policies.onsitefeedbackto.email},
    set: (val: string[]) => { setCustomerDeep({path: 'policies.onsitefeedbackto.email', data: val})}
  });

  // Compliance form to booked by
  const complianceformtobookedby = computed({
    get: () => { return customer.value.policies.complianceformto.bookedby},
    set: (val: boolean) => { setCustomerDeep({path: 'policies.complianceformto.bookedby', data: val})}
  });
  
  // Compliance form tolandlord
  const complianceformtolandlord = computed({
    get: () => { return customer.value.policies.complianceformto.landlord},
    set: (val: boolean) => { setCustomerDeep({path: 'policies.complianceformto.landlord', data: val})}
  });

  // Compliance form to to Email
  const complianceformtoemail = computed({
    get: () => { return customer.value.policies.complianceformto.email},
    set: (val: string[]) => { setCustomerDeep({path: 'policies.complianceformto.email', data: val})}
  });

  // CO cleaning feedback to booked by
  const cocleaningfeedbacktobookedby = computed({
    get: () => { return customer.value.policies.cocleaningfeedbackto.bookedby},
    set: (val: boolean) => { setCustomerDeep({path: 'policies.cocleaningfeedbackto.bookedby', data: val})}
  });

  // CO cleaning feedback to landlord
  const cocleaningfeedbacktolandlord = computed({
    get: () => { return customer.value.policies.cocleaningfeedbackto.landlord},
    set: (val: boolean) => { setCustomerDeep({path: 'policies.cocleaningfeedbackto.landlord', data: val})}
  });

  // CO cleaning feedback to Email
  const cocleaningfeedbacktoemail = computed({
    get: () => { return customer.value.policies.cocleaningfeedbackto.email},
    set: (val: string[]) => { setCustomerDeep({path: 'policies.cocleaningfeedbackto.email', data: val})}
  });

  //Confirm Access
  const confirmaccess = computed({
    get: () => { return customer.value.policies.confirmaccess},
    set: (val: boolean) => { setCustomerDeep({path: 'policies.confirmaccess', data: val})}
  });

  //Key release required
  const keyreleasereq = computed({
    get: () => { return customer.value.policies.keyreleasereq},
    set: (val: boolean) => { setCustomerDeep({path: 'policies.keyreleasereq', data: val})}
  });

  const deleteEmail = (key: string, index: number) => {
    const list: string[] = customer.value.policies[key].email;
    list.splice(index, 1);
    setCustomerDeep({path: key, data: [...list]});
  }
  const addEmail = (key: string, newvalue: string) => {
    const list: string[] = customer.value.policies[key].email;
    const index = list.findIndex((e: string) => e === newvalue);
    
    if(index < 0) { 
      list.push(newvalue);
      setCustomerDeep({path: key, data: [...list]});

      switch (key) {
        case 'onsitefeedbackto':
          onsitefeedbacktonewemail.value = '';
          break;
        case 'complianceformto':
        complianceformtonewemail.value = '';
          break;
        case 'cocleaningfeedbackto':
        cocleaningfeedbacktonewemail.value = '';
          break;
      }
    }
  }
  const updatevalidateEmail = (email) => {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      isupdateEmailValid.value = regex.test(email);
  };

  //validate email
  const validateEmail = () => {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      isEmailValid.value = regex.test(cocleaningfeedbacktonewemail.value || complianceformtonewemail.value || onsitefeedbacktonewemail.value || newcontact.value.email);
  };

return (_ctx: any,_cache: any) => {
  const _component_singleselect_text = _resolveComponent("singleselect-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", null, [
        _createElementVNode("fieldset", null, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.policies.smokecoalarms,
                onValueChanged: _cache[0] || (_cache[0] = ($event: any) => (setCustomerDeep({path: 'policies.smokecoalarms', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.policies.safetycleats,
                onValueChanged: _cache[1] || (_cache[1] = ($event: any) => (setCustomerDeep({path: 'policies.safetycleats', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.policies.summaryemailafterco,
                onValueChanged: _cache[2] || (_cache[2] = ($event: any) => (setCustomerDeep({path: 'policies.summaryemailafterco', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.policies.accessconfirm,
                onValueChanged: _cache[3] || (_cache[3] = ($event: any) => (setCustomerDeep({path: 'policies.accessconfirm', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.policies.donotcontactttforinvci,
                onValueChanged: _cache[4] || (_cache[4] = ($event: any) => (setCustomerDeep({path: 'policies.donotcontactttforinvci', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_unref(DxSwitch), {
                value: customer.value.policies.donotcontactttforcosoc,
                onValueChanged: _cache[5] || (_cache[5] = ($event: any) => (setCustomerDeep({path: 'policies.donotcontactttforcosoc', data: $event.value })))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((telephoneLetting).value = $event)),
                autocomplete: "telephoneletting"
              }, null, 512), [
                [
                  _vModelText,
                  telephoneLetting.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((emergencyphone).value = $event)),
                autocomplete: "emergencyphone"
              }, null, 512), [
                [
                  _vModelText,
                  emergencyphone.value,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.value.policies.contactlist, (poc, $pocindex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row mb-2",
                  key: $pocindex
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      autocomplete: "pocName",
                      class: "form-control",
                      "onUpdate:modelValue": ($event: any) => ((poc.name) = $event),
                      onChange: ($event: any) => (setCustomerDeep({path: `policies.contactlist[${$pocindex}].name`, data: poc.name}))
                    }, null, 40, _hoisted_32), [
                      [_vModelText, poc.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _withDirectives(_createElementVNode("input", {
                      type: "email",
                      autocomplete: "pocEmail",
                      class: _normalizeClass(["form-control", { 'is-invalid': !isupdateEmailValid.value && poc.email }]),
                      "onUpdate:modelValue": ($event: any) => ((poc.email) = $event),
                      onInput: ($event: any) => (updatevalidateEmail(poc.email)),
                      onChange: ($event: any) => (setCustomerDeep({path: `policies.contactlist[${$pocindex}].email`, data: poc.email}))
                    }, null, 42, _hoisted_34), [
                      [_vModelText, poc.email]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      autocomplete: "pocPhone",
                      class: "form-control",
                      pattern: "[0-9]{3}-[0-9]{2}-[0-9]{3}",
                      "onUpdate:modelValue": ($event: any) => ((poc.phone) = $event),
                      onChange: ($event: any) => (setCustomerDeep({path: `policies.contactlist[${$pocindex}].phone`, data: poc.phone}))
                    }, null, 40, _hoisted_36), [
                      [_vModelText, poc.phone]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _withDirectives(_createElementVNode("input", {
                      type: "tel",
                      autocomplete: "pocMobile",
                      class: "form-control",
                      pattern: "[0-9]{3}-[0-9]{2}-[0-9]{3}",
                      "onUpdate:modelValue": ($event: any) => ((poc.mobile) = $event),
                      onChange: ($event: any) => (setCustomerDeep({path: `policies.contactlist[${$pocindex}].mobile`, data: poc.mobile}))
                    }, null, 40, _hoisted_38), [
                      [_vModelText, poc.mobile]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_unref(DxSwitch), {
                      modelValue: poc.confirmationcc,
                      "onUpdate:modelValue": ($event: any) => ((poc.confirmationcc) = $event),
                      onValueChanged: ($event: any) => (setCustomerDeep({path: `policies.contactlist[${$pocindex}].confirmationcc`, data: $event.value}))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onValueChanged"])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_unref(DxSwitch), {
                      modelValue: poc.feedbackcc,
                      "onUpdate:modelValue": ($event: any) => ((poc.feedbackcc) = $event),
                      onValueChanged: ($event: any) => (setCustomerDeep({path: `policies.contactlist[${$pocindex}].feedbackcc`, data: $event.value}))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onValueChanged"])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-danger",
                      onClick: _withModifiers(($event: any) => (deletePointofcontact($pocindex)), ["prevent"])
                    }, _hoisted_44, 8, _hoisted_42)
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((newcontact.value.name) = $event)),
                    autocomplete: "newcontactname"
                  }, null, 512), [
                    [_vModelText, newcontact.value.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    class: _normalizeClass(["form-control", { 'is-invalid': !isEmailValid.value && newcontact.value.email }]),
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((newcontact.value.email) = $event)),
                    onInput: validateEmail,
                    autocomplete: "newcontactemail"
                  }, null, 34), [
                    [_vModelText, newcontact.value.email]
                  ])
                ]),
                _createElementVNode("div", _hoisted_48, [
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    class: "form-control",
                    pattern: "[0-9]{3}-[0-9]{2}-[0-9]{3}",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((newcontact.value.phone) = $event)),
                    autocomplete: "newcontactephone"
                  }, null, 512), [
                    [_vModelText, newcontact.value.phone]
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    class: "form-control",
                    pattern: "[0-9]{3}-[0-9]{2}-[0-9]{3}",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((newcontact.value.mobile) = $event)),
                    autocomplete: "newcontactemobile"
                  }, null, 512), [
                    [_vModelText, newcontact.value.mobile]
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: newcontact.value.confirmationcc,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((newcontact.value.confirmationcc) = $event)),
                    onValueChanged: _cache[13] || (_cache[13] = ($event: any) => (newcontact.value.confirmationcc = $event.value))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _createVNode(_unref(DxSwitch), {
                    modelValue: newcontact.value.feedbackcc,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((newcontact.value.feedbackcc) = $event)),
                    onValueChanged: _cache[15] || (_cache[15] = ($event: any) => (newcontact.value.feedbackcc = $event.value))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-outline-dark", { disabled: !canSavePOC() }]),
                    disabled: !canSavePOC(),
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (addPointofcontact()))
                  }, _hoisted_55, 10, _hoisted_53)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _hoisted_57,
            _createElementVNode("div", _hoisted_58, [
              _createVNode(_unref(DxSwitch), {
                value: inspectioninabs.value,
                onValueChanged: _cache[17] || (_cache[17] = ($event: any) => (inspectioninabs.value = $event.value))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _hoisted_60,
            _createElementVNode("div", _hoisted_61, [
              _createVNode(_unref(DxSwitch), {
                value: invciflex.value,
                disabled: !inspectioninabs.value,
                onValueChanged: _cache[18] || (_cache[18] = ($event: any) => (invciflex.value = $event.value))
              }, null, 8, ["value", "disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _hoisted_63,
            _createElementVNode("div", _hoisted_64, [
              _createVNode(_unref(DxSwitch), {
                value: invciflexam.value,
                disabled: !inspectioninabs.value,
                onValueChanged: _cache[19] || (_cache[19] = ($event: any) => (invciflexam.value = $event.value))
              }, null, 8, ["value", "disabled"])
            ])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _hoisted_66,
            _createElementVNode("div", _hoisted_67, [
              _createVNode(_unref(DxSwitch), {
                value: cosocflex.value,
                disabled: !inspectioninabs.value,
                onValueChanged: _cache[20] || (_cache[20] = ($event: any) => (cosocflex.value = $event.value))
              }, null, 8, ["value", "disabled"])
            ])
          ]),
          _hoisted_68,
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _createElementVNode("div", _hoisted_73, [
                  _createVNode(_unref(DxSwitch), {
                    value: onsitefeedbacktobookedby.value,
                    onValueChanged: _cache[21] || (_cache[21] = ($event: any) => (onsitefeedbacktobookedby.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createVNode(_unref(DxSwitch), {
                    value: onsitefeedbacktolandlord.value,
                    onValueChanged: _cache[22] || (_cache[22] = ($event: any) => (onsitefeedbacktolandlord.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        class: _normalizeClass(["form-control", { 'is-invalid': !isEmailValid.value && onsitefeedbacktonewemail.value }]),
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((onsitefeedbacktonewemail).value = $event)),
                        onInput: validateEmail,
                        autocomplete: "onsitefeedbacktoemail"
                      }, null, 34), [
                        [_vModelText, onsitefeedbacktonewemail.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_78, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["btn btn-outline-dark", { disabled: !isEmailValid.value || !onsitefeedbacktonewemail.value }]),
                        disabled: !isEmailValid.value || !onsitefeedbacktonewemail.value,
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (addEmail('onsitefeedbackto', onsitefeedbacktonewemail.value)))
                      }, _hoisted_81, 10, _hoisted_79)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      (onsitefeedbacktoemail.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_84, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(onsitefeedbacktoemail.value, (email, $index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: $index,
                                class: "multiselecttag"
                              }, [
                                _createTextVNode(_toDisplayString(email) + " ", 1),
                                _createElementVNode("i", {
                                  tabindex: "1",
                                  class: "multiselect__tag-icon",
                                  onClick: ($event: any) => (deleteEmail('onsitefeedbackto', $index))
                                }, null, 8, _hoisted_85)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_86, [
            _hoisted_87,
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, [
                  _createVNode(_unref(DxSwitch), {
                    value: complianceformtobookedby.value,
                    onValueChanged: _cache[25] || (_cache[25] = ($event: any) => (complianceformtobookedby.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_91, [
                  _createVNode(_unref(DxSwitch), {
                    value: complianceformtolandlord.value,
                    onValueChanged: _cache[26] || (_cache[26] = ($event: any) => (complianceformtolandlord.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, [
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        class: _normalizeClass(["form-control", { 'is-invalid': !isEmailValid.value && complianceformtonewemail.value }]),
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((complianceformtonewemail).value = $event)),
                        onInput: validateEmail,
                        autocomplete: "complianceformtoemail"
                      }, null, 34), [
                        [_vModelText, complianceformtonewemail.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["btn btn-outline-dark", { disabled: !isEmailValid.value || !complianceformtonewemail.value }]),
                        disabled: !isEmailValid.value || !complianceformtonewemail.value,
                        onClick: _cache[28] || (_cache[28] = ($event: any) => (addEmail('complianceformto', complianceformtonewemail.value)))
                      }, _hoisted_98, 10, _hoisted_96)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_99, [
                    _createElementVNode("div", _hoisted_100, [
                      (complianceformtoemail.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_101, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(complianceformtoemail.value, (email, $index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: $index,
                                class: "multiselecttag"
                              }, [
                                _createTextVNode(_toDisplayString(email) + " ", 1),
                                _createElementVNode("i", {
                                  tabindex: "1",
                                  class: "multiselect__tag-icon",
                                  onClick: ($event: any) => (deleteEmail('complianceformto', $index))
                                }, null, 8, _hoisted_102)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_103, [
            _hoisted_104,
            _createElementVNode("div", _hoisted_105, [
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("div", _hoisted_107, [
                  _createVNode(_unref(DxSwitch), {
                    value: cocleaningfeedbacktobookedby.value,
                    onValueChanged: _cache[29] || (_cache[29] = ($event: any) => (cocleaningfeedbacktobookedby.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_108, [
                  _createVNode(_unref(DxSwitch), {
                    value: cocleaningfeedbacktolandlord.value,
                    onValueChanged: _cache[30] || (_cache[30] = ($event: any) => (cocleaningfeedbacktolandlord.value = $event.value))
                  }, null, 8, ["value"])
                ]),
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("div", _hoisted_110, [
                    _createElementVNode("div", _hoisted_111, [
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        class: _normalizeClass(["form-control", { 'is-invalid': !isEmailValid.value && cocleaningfeedbacktonewemail.value }]),
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((cocleaningfeedbacktonewemail).value = $event)),
                        onInput: validateEmail,
                        autocomplete: "cocleaningfeedbacktoemail"
                      }, null, 34), [
                        [_vModelText, cocleaningfeedbacktonewemail.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_112, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["btn btn-outline-dark", { disabled: !isEmailValid.value || !cocleaningfeedbacktonewemail.value }]),
                        disabled: !isEmailValid.value || !cocleaningfeedbacktonewemail.value,
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (addEmail('cocleaningfeedbackto', cocleaningfeedbacktonewemail.value)))
                      }, _hoisted_115, 10, _hoisted_113)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_116, [
                    _createElementVNode("div", _hoisted_117, [
                      (cocleaningfeedbacktoemail.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_118, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cocleaningfeedbacktoemail.value, (email, $index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: $index,
                                class: "multiselecttag"
                              }, [
                                _createTextVNode(_toDisplayString(email) + " ", 1),
                                _createElementVNode("i", {
                                  tabindex: "1",
                                  class: "multiselect__tag-icon",
                                  onClick: ($event: any) => (deleteEmail('cocleaningfeedbackto', $index))
                                }, null, 8, _hoisted_119)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_120, [
            _hoisted_121,
            _createElementVNode("div", _hoisted_122, [
              _createVNode(_unref(DxSwitch), {
                value: keyreleasereq.value,
                onValueChanged: _cache[33] || (_cache[33] = ($event: any) => (keyreleasereq.value = $event.value))
              }, null, 8, ["value"])
            ])
          ]),
          _createElementVNode("div", _hoisted_123, [
            _hoisted_124,
            _createElementVNode("div", _hoisted_125, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.value.policies.openinghours, (oh, $ohindex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row",
                  key: $ohindex
                }, [
                  _createElementVNode("div", _hoisted_126, _toDisplayString(dayOfWeek[$ohindex]), 1),
                  _hoisted_127,
                  _createElementVNode("div", _hoisted_128, [
                    _createVNode(_unref(DxSwitch), {
                      modelValue: oh.closed,
                      "onUpdate:modelValue": ($event: any) => ((oh.closed) = $event),
                      onValueChanged: ($event: any) => {setCustomerDeep({path:`policies.openinghours[${$ohindex}].closed`, data:$event.value});}
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onValueChanged"])
                  ]),
                  _createElementVNode("div", _hoisted_129, [
                    _createVNode(_component_singleselect_text, {
                      modelValue: oh.from,
                      "onUpdate:modelValue": ($event: any) => ((oh.from) = $event),
                      options: getTimeOptionsForFrom(oh.to),
                      disabled: isDropdownDisabled(oh),
                      "allow-empty": true,
                      taggable: false,
                      onSelect: ($event: any) => (setOpeningTimeFrom($ohindex, $event))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled", "onSelect"])
                  ]),
                  _createElementVNode("div", _hoisted_130, [
                    _createVNode(_component_singleselect_text, {
                      modelValue: oh.to,
                      "onUpdate:modelValue": ($event: any) => ((oh.to) = $event),
                      options: getTimeOptionsForTo(oh.from),
                      disabled: oh.closed,
                      "allow-empty": true,
                      taggable: false,
                      onSelect: ($event: any) => (setOpeningTimeTo($ohindex, $event))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "disabled", "onSelect"])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_131, [
            _hoisted_132,
            _createElementVNode("div", _hoisted_133, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                rows: "10",
                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((customer.value.policies.uniquenotes) = $event)),
                onChange: _cache[35] || (_cache[35] = ($event: any) => (editCurrentCustomer()))
              }, null, 544), [
                [
                  _vModelText,
                  customer.value.policies.uniquenotes,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_134, [
            _hoisted_135,
            _createElementVNode("div", _hoisted_136, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                rows: "10",
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((customer.value.policies.longtermpinotes) = $event)),
                onChange: _cache[37] || (_cache[37] = ($event: any) => (editCurrentCustomer()))
              }, null, 544), [
                [
                  _vModelText,
                  customer.value.policies.longtermpinotes,
                  void 0,
                  { lazy: true }
                ]
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})